import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import { RootState, useDispatch, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    image_left_button: ['image_left_button'],
    image_right_button: ['image_right_button'],
    bottom_left_button: ['bottom_left_button'],
    bottom_right_button: ['bottom_right_button'],
    image_button: ['image_button']
  }
};

const ChoiceButtonModalTracking: FC = () => {
  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let btnType = useSelector((state: RootState) => state.buttons.btnType);

  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
  }
  .content_tracking_wrapper {
    width: 100%;          
    height: 100%;
    
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    gap: 100px;    
  }
  .center_tracking {
    width: 100%;
    gap: 5px;
    display: flex;
    flex-direction: column;    
    align-items: end;
    justify-content: end;
  }  

   .btn_tracking_wrapper {
    width: 100%;    
    gap: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    }           
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <>
        <div className="root_tracking">
          <div className="content_tracking_wrapper">
            <div className="center_tracking">
              {btnType === 'single' ? (
                <EditTracking
                  value={tracking?.image_button}
                  type="image_button"
                />
              ) : (
                <>
                  <EditTracking
                    value={tracking?.image_left_button}
                    type="image_left_button"
                  />
                  <EditTracking
                    value={tracking?.image_right_button}
                    type="image_right_button"
                  />
                </>
              )}
            </div>
            <div className="btn_tracking_wrapper">
              <EditTracking
                value={tracking?.bottom_left_button}
                type="bottom_left_button"
              />

              <EditTracking
                value={tracking?.bottom_right_button}
                type="bottom_right_button"
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default ChoiceButtonModalTracking;
